import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { EmpireStateCode, ProductAmount } from '../../wizumen-models';

@Component({
  selector: 'wizumen-product-icon',
  template: `
    <span class="wizumen-product-icon flex align-center {{productStyles}}">
        <i class="eva-3-icon-{{product.icon}}{{isV2 ? '-ui' : ''}} eva-icon"></i>
        <em class="wizumen-product-count">{{product.amount}}</em>
    </span>
  `,
  styleUrls: ['./wizumen-product-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenProductIconComponent implements OnInit {
  @Input() product: ProductAmount;
  @Input() isV2: boolean | undefined;

  productStyles: string;

  ngOnInit() {
    if (this.product.amount > 0) {
      this.productStyles = this.resolveIconColorStatus();
    }
  }

  resolveIconColorStatus(): string {

    if (EmpireStateCode.CONFIRMED === this.product.product_status) {
      return '-confirmed';
    }
    if (EmpireStateCode.OPEN === this.product.product_status) {
      return '-warning';
    }
    return '-alert'
  }
}
